import { render, staticRenderFns } from "./GameBuddyApply.vue?vue&type=template&id=5bee2049&scoped=true"
import script from "./GameBuddyApply.vue?vue&type=script&lang=js"
export * from "./GameBuddyApply.vue?vue&type=script&lang=js"
import style0 from "./GameBuddyApply.vue?vue&type=style&index=0&id=5bee2049&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bee2049",
  null
  
)

export default component.exports